(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ba-hit-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
  const mobile = window.matchMedia('(max-width: 749px)');
  const records = new Map();
  const retained = '[data-ba-hit-open], .ba-hit-archive-card__image, dialog, template, script, style';

  function syncGallery(gallery) {
    gallery.querySelectorAll('[data-ba-hit-card]').forEach(function (card) {
      let record = records.get(card);
      if (!record) {
        record = { entries: [], details: null, mobileOpen: false };
        records.set(card, record);
      }
      if (mobile.matches && !record.details) {
        const nodes = Array.from(card.childNodes).filter(function (node) {
          return node.nodeType === 1 ? !node.matches(retained) : node.nodeType === 3 && node.textContent.trim() !== '';
        });
        if (!nodes.length) return;
        const details = document.createElement('details');
        details.className = 'ba-hit-details';
        const summary = document.createElement('summary');
        summary.className = 'ba-hit-details__summary';
        const label = document.createElement('span');
        label.textContent = gallery.dataset.baDetailsLabel;
        summary.append(label);
        const title = card.querySelector('h3');
        if (title) {
          const context = document.createElement('span');
          context.className = 'visually-hidden';
          context.textContent = ': ' + title.textContent.trim();
          summary.append(context);
        }
        const body = document.createElement('div');
        body.className = 'ba-hit-details__body';
        details.append(summary, body);
        record.entries = nodes.map(function (node) {
          const marker = document.createComment('ba-hit-details');
          card.insertBefore(marker, node);
          body.append(node);
          return { node: node, marker: marker };
        });
        details.open = record.mobileOpen;
        card.append(details);
        record.details = details;
      } else if (!mobile.matches && record.details) {
        record.mobileOpen = record.details.open;
        record.entries.forEach(function (entry) {
          entry.marker.replaceWith(entry.node);
        });
        record.details.remove();
        record.details = null;
        record.entries = [];
      }
    });
  }

  function sync(root) {
    records.forEach(function (_record, card) {
      if (!card.isConnected) records.delete(card);
    });
    if (root.matches && root.matches('.ba-hit-gallery')) syncGallery(root);
    root.querySelectorAll('.ba-hit-gallery').forEach(syncGallery);
  }

  function ready() { sync(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready, { once: true });
  } else {
    ready();
  }
  mobile.addEventListener('change', ready);
  document.addEventListener('shopify:section:load', function (event) { sync(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    records.forEach(function (_record, card) {
      if (event.target.contains(card)) records.delete(card);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"] && !Shopify.designMode) return;
  try {
    
(() => {
  let pending;
  let generation = 0;
  const topic = '(?:fotball|baseball|nfl|nba|marvel-disney|star-wars|formel-1|kampsport|diverse)';
  const modePath = new RegExp('/collections/(?:apnes-live|send-hjem)(?:-' + topic + ')?/?$');

  async function navigateMode(url, push, focus) {
    const current = document.querySelector('[data-ba-mode-browser]');
    if (!current) return;
    pending?.abort();
    const controller = new AbortController();
    pending = controller;
    const request = ++generation;
    current.setAttribute('aria-busy', 'true');
    const status = current.querySelector('[data-ba-mode-status]');
    if (status) status.textContent = 'Laster produkter …';
    try {
      const response = await fetch(url, { signal: controller.signal, headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('Collection response failed');
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (request !== generation) return;
      const next = page.querySelector('[data-ba-mode-browser]');
      const heading = document.querySelector('.collection-hero__title');
      const nextHeading = page.querySelector('.collection-hero__title');
      if (!next || !heading || !nextHeading || next.dataset.baMode !== current.dataset.baMode) throw new Error('Collection markup missing');
      current.replaceWith(next);
      heading.replaceChildren(...nextHeading.childNodes);
      document.title = page.title;
      const canonical = document.querySelector('link[rel="canonical"]');
      const nextCanonical = page.querySelector('link[rel="canonical"]');
      if (canonical && nextCanonical) canonical.href = nextCanonical.href;
      if (push) history.pushState({ baModeNavigation: true }, '', url);
      const nextStatus = next.querySelector('[data-ba-mode-status]');
      if (nextStatus) nextStatus.textContent = 'Produktene er oppdatert.';
      const header = document.querySelector('.section-header');
      const fixedHeader = header && ['sticky', 'fixed'].includes(getComputedStyle(header).position);
      const top = next.getBoundingClientRect().top + window.scrollY - (fixedHeader ? header.offsetHeight : 0) - 20;
      window.scrollTo({ top: Math.max(0, top), behavior: 'instant' });
      if (focus) next.focus({ preventScroll: true });
    } catch (error) {
      if (error.name !== 'AbortError' && request === generation) window.location.assign(url);
    } finally {
      if (request === generation) { pending = null; current.removeAttribute('aria-busy'); }
    }
  }

  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('[data-ba-mode-browser] .ba-mode-categories a, [data-ba-mode-browser] .ba-mode-pagination a');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    const url = new URL(link.href);
    if (url.origin !== location.origin || !modePath.test(url.pathname)) return;
    event.preventDefault();
    if (url.href !== location.href || pending) navigateMode(url.href, true, event.detail === 0);
  });
  window.addEventListener('popstate', () => {
    if (!document.querySelector('[data-ba-mode-browser]')) return;
    if (modePath.test(location.pathname)) navigateMode(location.href, false, false);
    else window.location.reload();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
